import * as React from "react";
import {useEffect} from "react";
import {TopPage} from "./Toppage";
import {Floatinglogo} from "./Floatinglogo";
import {TopContainer} from "./TopContainer";
import 'vanilla-cookieconsent/dist/cookieconsent.css';

export type Categories = 'videos' | 'livecams' | 'chatting';
export type typeStateCategories = {
    state: [Categories, React.Dispatch<React.SetStateAction<Categories>>]
};

export const videoModelHrefs = ['Hanna', 'Lana', 'Leni', 'Lexy', 'Lia'];
const livecamModelHrefs = ['Kate', 'Leni', 'Lovin', 'Mia', 'Nele'];
const chattingModelHrefs = videoModelHrefs.toSpliced(videoModelHrefs.indexOf('Leni'), 1, 'Mia');

export enum ProfileFullNames {
    Hanna = 'Hanna Secret',
    Lana = 'Lana Grey',
    Leni = 'Leni Fesch',
    Lexy = 'Lexy Roxx',
    Lia = 'Lia Engel',
    Kate = 'Kate Monroe',
    Lovin = 'LovinLou',
    Mia = 'Mia-Nouvelle',
    Nele = 'Nele Sommer'
}

export enum ProfilePCs {
    Lia = 'LIAFR33V1D',
    Hanna = 'HANNAFR33HC',
    Lana = 'LANAFRE3GZ',
    Lexy = 'LEXYFR3EHC',
    Leni = 'LENIFR3EAF',
}

export const Layout = () => {
    const state = React.useState<Categories>('livecams');
    const [category] = state;

    useEffect(() => {
        void import('vanilla-cookieconsent').then((CookieConsent) => {
            void CookieConsent.run({
                cookie: {
                    name: 'cookie_consent',
                    expiresAfterDays: 365 * 2,
                },
                categories: {
                    necessary: {
                        enabled: true,
                        readOnly: true,
                    },
                    functional: {
                        enabled: false,
                    },
                },
                language: {
                    default: 'de',
                    autoDetect: 'document',
                    translations: {
                        de: {
                            consentModal: {
                                title: 'Wir nutzen Cookies!',
                                description: 'Wir verwenden Cookies, um Ihr Erlebnis auf unserer Website so angenehm wie möglich zu gestalten und um unser Produkt zu verbessern. Weitere Informationen über unsere Datenerfassungspraktiken finden Sie in unserer <a id="datenschutz-cookie2" href="/datenschutz.html">Datenschutzrichtlinie</a>.<br/><br/>Sie können entscheiden welche Cookies Sie zulassen oder ablehnen. Klicken Sie auf "Einstellungen", um eine Liste aller Kategorien angezeigt zu bekommen. Durch Klicken auf "Alle Akzeptieren" erklären Sie sich mit der Verwendung der Cookies einverstanden.',
                                acceptAllBtn: 'Alle akzeptieren',
                                showPreferencesBtn: 'Einstellungen',
                            },
                            preferencesModal: {
                                title: 'Cookie Einstellungen',
                                savePreferencesBtn: 'Speichern',
                                acceptAllBtn: 'Alle akzeptieren',
                                acceptNecessaryBtn: 'Alle ablehnen',
                                closeIconLabel: 'Schließen',
                                sections: [
                                    {
                                        title: 'Cookie Nutzung',
                                        description: 'Unsere Cookies fallen in folgende Kategorien',
                                    },
                                    {
                                        title: 'Essentielle Cookies',
                                        description: 'Diese Cookies sind notwendig für den einwandfreien technischen Betrieb der Webseite.',
                                        linkedCategory: 'necessary',
                                    },
                                    {
                                        title: 'Funktionale Cookies',
                                        description: 'Diese Cookies verbessern die Nutzererfahrung auf unserer Website, indem sie sich deine bevorzugten Einstellungen merken, wie z.B. die Länderauswahl.',
                                        linkedCategory: 'functional',
                                    },
                                    {
                                        title: 'Mehr Informationen',
                                        description: 'Für weitere Informationen zum Thema Datenschutz lies unsere <a id="/datenschutz-cookie" href="/datenschutz.html">Datenschutzerklärung.</a>',
                                    },
                                ],
                            },
                        },
                    },
                },
            });
        });
    }, [])

    return (
        <div className="std-padding">
            <TopPage state={state}/>
            <Floatinglogo/>
            <TopContainer
                state={state}
                modelShortNames={
                    category === 'videos' ?
                        videoModelHrefs
                        :
                        category === 'livecams' ?
                            livecamModelHrefs
                            :
                            chattingModelHrefs}
            />
            <hr/>
        </div>
    )
}
